import nProgress from "nprogress";
import { memo, useEffect } from "react";

const PageLoading = () => {
  useEffect(() => {
    nProgress.start();

    return () => {
      nProgress.done();
    };
  }, []);

  return null;
};

export default memo(PageLoading);
